<template>
  <div class="table-list">
    <div class="wiki-title">
      <div class="row-title">
        <h2>{{ tableInfo['title'] || '未知标题' }}</h2>

        <div class="row-title-tag">
          <em class="wait" v-if="tableInfo.status == 0">等待采集</em>
          <em class="processing" v-if="tableInfo.status == 1">正在采集</em>
          <em class="success" v-if="tableInfo.status == 2">采集成功</em>
          <em class="failure" v-if="tableInfo.status == -1">采集失败 </em>
        </div>
      </div>

      <div class="row">
        <div class="title">
          <h1>分类</h1>
        </div>
        <div v-for="subject in tableInfo['subjects']">
          <div class="keywords-container">
            <div class="keyword">{{ subject.subjectName }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrap" v-for="(table, table_index) in tableData" :key="table_index">
      <div>
        <h2>{{ table.title }}</h2>
      </div>
      <div class="table-item">
        <div class="table-row" v-for="(row, row_index) in table.data_list" :key="row_index">
          <span
            :class="[col.link != '' ? 'link' : '', row_index == 0 ? 'table-header' : '']"
            v-for="(col, col_index) in row"
            :key="col_index"
          >
            <span   v-if="hadCrawlMap[col['link']] != null" class="hadCrawl" @click="hadCrawl(col)">
              {{ col.name }}
            </span>
            <span style="border: none" v-if="!hadCrawlMap[col['link']]"> {{ col.name }} </span>

            <span
              v-if="row_index == 0 && linkMap[table_index + '_' + col_index]"
              @click="handleShowDialog(table_index, col_index, table.data_list)"
              class="slide-down"
            >
              <icon name="down" scale="14" style="margin-right: -14px"></icon>
            </span>
          </span>
        </div>
      </div>
    </div>

    <a-modal
      title="采集数据"
      :bodyStyle="{ padding: '6px 55px 28px' }"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button style="" v-if="currentCrawlStatus == 0" key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button
          v-if="currentCrawlStatus == 0"
          key="submit"
          type="primary"
          :loading="crawlLoading"
          @click="handleBeginCollect"
        >
          采集
        </a-button>

        <a-button v-if="currentCrawlStatus == 1" key="submit" type="primary" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <div class="craw-select-box">
        <div class="select-title">
          <div class="select-btn">
            <div
              class="select-btn-font"
              :class="{ 'select-btn-font-selected': currentCrawlStatus == 0 }"
              @click="changeCrawlBtn(0)"
            >
              <div style="margin-top: 3px">
                <span style="vertical-align: middle; padding-right: 7px">
                  <a-icon type="cloud-download" />
                </span>
                <span style="font-size: 15px">采集</span>
              </div>
            </div>

            <div
              class="select-btn-font"
              :class="{ 'select-btn-font-selected': currentCrawlStatus == 1 }"
              @click="changeCrawlBtn(1)"
            >
              <div style="margin-top: 3px">
                <span style="vertical-align: middle; padding-right: 7px"><a-icon type="clock-circle"/></span>
                <span style="font-size: 15px">进度</span>
              </div>
            </div>
          </div>
        </div>

        <div v-show="currentCrawlStatus == 0">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
            class="select-all-btn"
          >
            全选
          </a-checkbox>
          <vue-scroll class="check-scroll" :ops="scrollerOps">
            <div class="select-checkbox">
              <a-checkbox-group v-model="selectList" @change="onChange">
                <div class="check-item" v-for="(item, index) in loadList" :key="index">
                  <a-checkbox :value="item.link">
                    {{ item.name }}
                  </a-checkbox>
                </div>
              </a-checkbox-group>
            </div>
          </vue-scroll>
        </div>

        <div v-show="currentCrawlStatus == 1">
          <div>
            <vue-scroll class="check-scroll" style="margin-top: 26px" :ops="scrollerOps">
              <div
                class="check-scroll"
                :infinite-scroll-disabled="true"
                :infinite-scroll-distance="10"
              >
                <a-list>
                  <a-list-item v-for="(item, index) in processList" :key="index">
                    <em class="wait" v-if="item.status == 0">等待采集</em>
                    <em class="processing" v-if="item.status == 1">正在采集</em>
                    <em class="success" v-if="item.status == 2">采集成功</em>
                    <em class="failure" v-if="item.status == -1">采集失败 </em>
                    <em class="none" v-if="item.status == -100">暂未采集</em>
                    {{ item.title | stringCut(18) }}

                    <a v-if="item.status == -100" class="crawl" @click="handleCrawl(item, false)">采集</a>

                    <a v-if="item.status == -1" class="crawl" @click="handleCrawl(item, true)">重新采集</a>
                  </a-list-item>
                </a-list>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  queryCollectDetaileByIdApi,
  queryByIdsOrUrlsApi,
  queryHadCrawlApi
} from '@/api/TopicCrawl/CollectInfo'
import { addSubjectContentApi } from '@/api/TopicCrawl/CollectList'
import stringUtil from '@/utils/string'
import infiniteScroll from 'vue-infinite-scroll'
// import { line } from '@antv/g2plot'?
export default {
  directives: { infiniteScroll },
  data() {
    return {
      tableData: [],
      checkedList: [],
      visible: false,
      loadMap: {},
      urlToNameMap: {},
      loadList: [],
      selectList: [],
      subjectId: '',
      subjectContentId: '',
      key: '',
      processList: [],
      tableInfo: {},
      indeterminate: true,
      checkAll: false,
      crawlLoading: false,
      currentCrawlStatus: 0,
      scrollerOps: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          // background: "#F5F5F5",//滚动条颜色
          opacity: 1.0, //滚动条透明度
          'overflow-x': 'hidden'
        }
      },
      linkMap: {},
      hadCrawlMap: {}
    }
  },
  created() {
    let { subjectId, subjectContentId, type } = this.$route.query
    this.subjectId = subjectId
    this.subjectContentId = subjectContentId
    this.type = type
    this.queryCollectDetaileById()
    this.queryHadCrawl(this.subjectContentId, this.subjectId)
  },
  methods: {
    async queryHadCrawl(subjectContentId, subjectId) {
      let res = await queryHadCrawlApi({
        tableId: subjectContentId,
        status: 2,
        subjectId
      })

      let { data, code } = res
      if (code == 200 && data.length > 0) {
        data.forEach((item) => {
          this.hadCrawlMap[item['url']] = item['subjectContentId']
        })
      }
    },
    getPostData() {
      let postData = this.selectList.map((item) => {
        return {
          url: item,
          type: 'content'
        }
      })
      return postData
    },
    async handleBeginCollect() {
      this.crawlLoading = true
      const res = await addSubjectContentApi(
        { subjectId: this.subjectId, subjectContentId: this.subjectContentId, crawlAllFlag: false },
        this.getPostData()
      )
      this.crawlLoading = false
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.currentCrawlStatus = 1
      } else {
        this.$message.error(msg)
      }
    },

    async handleCrawl(item, crawlAllFlag) {
      const res = await addSubjectContentApi(
        {
          subjectId: this.subjectId,
          subjectContentId: this.subjectContentId,
          crawlAllFlag: crawlAllFlag
        },
        [
          {
            url: item['url'],
            type: 'content'
          }
        ]
      )
      this.crawlLoading = false
      const { code, msg } = res
      if (code == '200') {
        item['status'] = 0
        this.$message.success(msg)
        this.queryHadCrawl(this.subjectContentId)
      } else {
        this.$message.error(msg)
      }
    },

    hadCrawl(item) {
      let subjectContentId = this.hadCrawlMap[item['link']]
      if (subjectContentId) {
        this.$router.push({
          name: 'wikipedia_info',
          query: { subjectContentId, type: 'content' }
        })
      }
    },

    async queryByIdsOrUrlsApi() {
      this.processList = []
      let selectList = this.getCurrentLinks()
      if (selectList == null && selectList.length == 0) {
        return
      }

      let tempProcessMap = {}
      const res = await queryByIdsOrUrlsApi(
        { queryType: 'url', subjectId: this.subjectId },
        selectList
      )
      const { code, msg, data } = res
      if (code == '200') {
        data.forEach((item) => {
          tempProcessMap[item['url']] = this.getModalProcessItem(item)
        })

        this.loadMap[this.key].lists.forEach((item) => {
          if (tempProcessMap[item['link']]) {
            let tempItem = tempProcessMap[item['link']]
            tempItem['title'] = item['name'] || '未知标题'
            this.processList.push(tempItem)
          } else {
            this.processList.push(this.getFakeModalProcessItem(item))
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    async queryCollectDetaileById() {
      let { subjectContentId } = this.$route.query
      let res = await queryCollectDetaileByIdApi({ subjectContentId })
      let { code, msg, extra } = res
      if (code == '200') {
        this.tableInfo['title'] = extra.content.title
        this.tableInfo['subjects'] = extra.content.subjects
        this.tableInfo['status'] = extra.content.status
        this.tableData = extra.content.table_info
        this.dealTableData()
      } else {
        this.$message.error(msg)
      }
    },
    handleShowDialog(table_index, col_index, table) {

      let key = table_index + '_' + col_index
      this.key = key

      if (!this.loadMap[key]) {
        let tempMap = {}
        let result = []
        let data = table.slice(1)
        data.forEach((item) => {
          if (item != null && item.length > col_index) {
            let detail = item[col_index]
            if (!stringUtil.isNull(detail['link'])) {
              if (null == tempMap[detail['link']]) {
                tempMap[detail['link']] = true
                result.push(detail)
              }
            }
          }
        })
        let downLoadData = []
        result.forEach((item) => {
          if (item.link != '') {
            downLoadData.push(item)
          }
        })
        this.loadMap[key] = {
          select: [],
          lists: JSON.parse(JSON.stringify(downLoadData))
        }
      }

      this.loadList = this.loadMap[key].lists

      this.urlToNameMap = {}
      for (let item of this.loadList) {
        this.urlToNameMap[item.link] = item.name
      }
      this.selectList = this.loadMap[key].select
      this.visible = true
      this.currentCrawlStatus = 0
      this.checkAll = false
    },
    onChange(val) {
      this.loadMap[this.key].select = val
      this.checkAll = this.loadMap[this.key].select.length === this.loadMap[this.key].lists.length
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        selectList: e.target.checked ? this.getCurrentLinks() : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    getCurrentLinks() {
      let links = []
      if (this.loadMap[this.key]) {
        this.loadMap[this.key].lists.forEach((item) => {
          links.push(item['link'])
        })
      }
      return links
    },
    getModalProcessItem(item) {
      return {
        url: item['url'],
        status: item['status'],
        title: item['title']
      }
    },
    getFakeModalProcessItem(item) {
      return {
        url: item['link'],
        status: -100,
        title: item['name']
      }
    },

    changeCrawlBtn(val) {
      this.currentCrawlStatus = val
      if (val == 0) {
      } else {
        this.queryByIdsOrUrlsApi()
      }
    },

    /**
     * 遍历某一行是否可以下拉
     */
    dealTableData() {
      if (this.tableData != null) {
        this.tableData.forEach((table, index) => {
          if (table.data_list != null) {
            table.data_list.forEach((tableLines, linesIndex) => {
              if (tableLines != null) {
                tableLines.forEach((line, lineIndex) => {
                  if (line != null && line['link'] != null && line['link'] != '') {
                    this.linkMap[index + '_' + lineIndex] = true
                  }
                })
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.table-list {
  height: 100%;
  padding: 16px;
  .table-wrap {
    white-space: pre-line;
    padding: 16px;
    background: #fff;
    margin-bottom: 20px;
    .table-item {
      border: 1px solid #e2e2e2;
      border-radius: 2px;
      .table-row {
        display: flex;
        border-bottom: 1px solid #e2e2e2;
        .hadCrawl {
          cursor: pointer;
          color: #60a55a;
          border-bottom: solid 1px #ccc;
        }
        &:first-child {
          background: #f2f6fb;
        }
        &:last-child {
          border-bottom: none;
        }
        span {
          display: flex;
          align-items: center;
          flex: 1;
          min-height: 44px;
          vertical-align: middle;
          padding: 5px 10px;
          border-right: 1px solid #e2e2e2;
          position: relative;
          &.link {
            color: #0440b9;
            font-weight: 500;
          }
          &.table-header {
            font-size: 18px;
            font-weight: 800;
          }
          .slide-down {
            position: absolute;
            right: 10px;
            color: #3c93ff;
            font-size: 20px;
            cursor: pointer;
            .aaa {
              font-size: 16px;
            }
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.check-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .check-item {
    /*flex: 0 0 50%;*/
  }
}

.collect-btn {
  padding: 10px 0px 0;
}
.process {
  li {
    line-height: 20px;
    margin-bottom: 10px;
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    align-items: center;
    span {
      flex: 1;
    }
  }
}

.craw-select-box {
  display: block;
  .select-title {
    display: block;
    .select-btn {
      display: inline-block;
    }
    .select-btn-font {
      display: inline-block;
      width: 205px;
      height: 45px;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      font-size: 22px;
      text-align: center;
      margin-top: 5px;
      cursor: pointer;
    }

    .select-btn-font-selected {
      background-color: #3c93ff;
      color: white;
    }
  }
  .select-all-btn {
    margin-top: 5px;
  }
  .check-scroll {
    height: 350px !important;

    .crawl {
      float: right;
      width: 60px;
      margin-right: 10px;
      text-align: center;
    }
    .select-checkbox {
      margin-top: 8px;
      background-color: #f0f2f5;

      .check-item {
        padding: 5px 5px 5px 25px;
        /*line-height: 30px;*/
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        /*white-space: nowrap;*/
      }
    }
  }
}
em {
  padding: 3px 5px;
  width: 90px;
  margin-right: 10px;
  border-radius: 2px;
  font-style: normal;

  text-align: center;

  &.success {
    background: #f0faef;
    border: 0.1px solid #66c25d;
    border-radius: 4px;
  }

  &.none {
    background: #f9e4e6;
    border: 0.1px solid #e89fa6;
    border-radius: 4px;
  }

  &.wait {
    background: #f0f2f5;
    border: 1px solid #b5bbc3;
    border-radius: 4px;
  }
  &.failure {
    background: #fff6e2;
    border: 0.5px solid #ffc852;
    border-radius: 4px;
  }
  &.processing {
    background: #f0f7ff;
    border: 1px solid #3c93ff;
    border-radius: 4px;
  }
}

.wiki-title {
  padding: 10px 0px 0px 0px;
  background: white;

  margin-bottom: 16px;

  .row-title {
    display: flex;
    margin-bottom: 0px;
    align-items: center;
    font-size: 16px;

    margin-left: 1.5em;

    padding-bottom: 10px;

    .row-title-tag {
      font-size: 14px;
      margin-left: 15px;
    }

    .title {
      margin-bottom: 2px;
    }
  }

  .row {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin-left: 2em;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 10px;
    .title {
      margin-bottom: -8px;
    }
    .keywords-container {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-left: 1em;
      .keyword {
        text-align: center;
        border: 1px solid #eeeeee;
        color: #999999;
        border-radius: 5px;
        padding: 5px 20px;
      }
    }

    .download {
      color: blue;
    }
  }
}
.anticon-down-square {
  background: #3c93ff;
  color: white;
}
</style>
